import React, { FunctionComponent } from "react";
import { Tooltip } from "../../../components";

export interface MedigapPlanDetailsTable {
  title: string | JSX.Element;
  footerNotes: { text: string | JSX.Element; id?: string }[];
  data: ({
    property: string;
    value:
      | string
      | number
      | JSX.Element
      | ({
          property: string;
          value: string | number | JSX.Element;
          hide?: boolean;
        } | null)[];
    tooltip?: string;
    hide?: boolean;
  } | null)[];
}

interface PlanDetailsTableProps {
  table: MedigapPlanDetailsTable;
}

const PlanDetailsTable: FunctionComponent<PlanDetailsTableProps> = ({
  table,
}) => {
  return (
    <>
      <h2 className="MedigapPlanDetails__tableTitle">{table.title}</h2>

      <div className="MedigapPlanDetails__table">
        {table.data.map((data, i) => {
          return data ? (
            data.hide ? null : (
              <div key={i} className="MedigapPlanDetails__tableRow">
                <div className="MedigapPlanDetails__tableDataProperty">
                  {data.tooltip ? (
                    <Tooltip title={data.property} triggerText={data.property}>
                      <p className="ds-u-font-size--small">{data.tooltip}</p>
                    </Tooltip>
                  ) : (
                    data.property
                  )}
                </div>
                <div className="MedigapPlanDetails__tableDataValue">
                  {Array.isArray(data.value) ? (
                    <ul className="ds-c-list--bare">
                      {data.value.map((v, i) => {
                        if (!v || v.hide) return;

                        return (
                          <li className="ds-u-margin-bottom--1" key={i}>
                            {v.property}: {v.value}
                          </li>
                        );
                      })}
                    </ul>
                  ) : (
                    data.value
                  )}
                </div>
              </div>
            )
          ) : (
            <React.Fragment key={i}></React.Fragment>
          );
        })}

        {!!table.footerNotes.length && (
          <ul className="ds-c-list--bare">
            {table.footerNotes
              .filter(footnote => !!footnote.text)
              .map((note, i) => (
                <li
                  className="ds-c-list--bare ds-u-margin-top--2"
                  id={note.id}
                  key={i}
                >
                  {note.text}
                </li>
              ))}
          </ul>
        )}
      </div>
    </>
  );
};

export default PlanDetailsTable;
